export enum MergeTagMenuCategory {
  Document = 'document',
  Custom = 'custom',
  Sender = 'sender',
  Recipient = 'recipient',
}
